// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#sidebar {
    min-width: 200px;
    max-width: 200px;
    background-color: var(--sk_nav);
    color: var(--sk_text_inverse);
}
#sidebar.active {
    min-width: 70px;
    max-width: 70px;
    text-align: center;
}

#sidebar > ul {
    position:fixed;
    top:100px;
    width:200px;
}

#sidebar > div {
    position:fixed;
}

#sidebar .sidebar-header {
    padding-top: 10px;
    padding-left: 60px;
    padding-right: 20px;
    padding-bottom: 35px;
}
#sidebar.active .sidebar-header {
    padding: 0px;
    padding-top: 10px;
}

#sidebar.active .sidebar-header h3 {
    display: none;
}

#sidebar .sidebar-header p {
    display: none;
    font-size: 1.8rem;
}
#sidebar.active .sidebar-header p {
    display: block;
}

#sidebar ul li a {
    padding: 10px;
    font-size: 1rem;
    display: block;
    text-align: left;
}
#sidebar ul li a:hover {
    background-color: #ff9a00!important;;
}
#sidebar ul div li a {
    font-size: 0.85rem;
}

#sidebar ul li.active {
    font-weight: bold;
    color: var(--sk_selected);
    background-color: #bababa!important;
}

.color-nav {
    background-color: var(--main-light-hg-color) !important;
}

@media (max-width: 992px) {
    #sidebar {
        min-width: 70px;
        max-width: 70px;
        text-align: center;
    }

    #sidebar > ul {
        width:70px;
    }

    #sidebar .sidebar-header {
        padding: 0px;
        padding-top: 10px;
    }
    #sidebar .sidebar-header h3 {
        display: none;
    }
    #sidebar .sidebar-header p {
        display: block;
        padding-left: 15px;
    }

    #sidebar ul li a {
        width:100%;
    }

    #sidebar ul li>a span {
        display:none;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/menu.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;IAC/B,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,mCAAmC;AACvC;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI;QACI,eAAe;QACf,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["\n#sidebar {\n    min-width: 200px;\n    max-width: 200px;\n    background-color: var(--sk_nav);\n    color: var(--sk_text_inverse);\n}\n#sidebar.active {\n    min-width: 70px;\n    max-width: 70px;\n    text-align: center;\n}\n\n#sidebar > ul {\n    position:fixed;\n    top:100px;\n    width:200px;\n}\n\n#sidebar > div {\n    position:fixed;\n}\n\n#sidebar .sidebar-header {\n    padding-top: 10px;\n    padding-left: 60px;\n    padding-right: 20px;\n    padding-bottom: 35px;\n}\n#sidebar.active .sidebar-header {\n    padding: 0px;\n    padding-top: 10px;\n}\n\n#sidebar.active .sidebar-header h3 {\n    display: none;\n}\n\n#sidebar .sidebar-header p {\n    display: none;\n    font-size: 1.8rem;\n}\n#sidebar.active .sidebar-header p {\n    display: block;\n}\n\n#sidebar ul li a {\n    padding: 10px;\n    font-size: 1rem;\n    display: block;\n    text-align: left;\n}\n#sidebar ul li a:hover {\n    background-color: #ff9a00!important;;\n}\n#sidebar ul div li a {\n    font-size: 0.85rem;\n}\n\n#sidebar ul li.active {\n    font-weight: bold;\n    color: var(--sk_selected);\n    background-color: #bababa!important;\n}\n\n.color-nav {\n    background-color: var(--main-light-hg-color) !important;\n}\n\n@media (max-width: 992px) {\n    #sidebar {\n        min-width: 70px;\n        max-width: 70px;\n        text-align: center;\n    }\n\n    #sidebar > ul {\n        width:70px;\n    }\n\n    #sidebar .sidebar-header {\n        padding: 0px;\n        padding-top: 10px;\n    }\n    #sidebar .sidebar-header h3 {\n        display: none;\n    }\n    #sidebar .sidebar-header p {\n        display: block;\n        padding-left: 15px;\n    }\n\n    #sidebar ul li a {\n        width:100%;\n    }\n\n    #sidebar ul li>a span {\n        display:none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
